export default __webpack_public_path__ + "static/media/frame-login-tablet@2x.c2ae6419.png";